import { useHouseholdDataUpdate } from "@/hooks/useHouseholdDataUpdate";
import { HouseholdDataType } from "@/types/enums";
import { useQueryClient } from "@tanstack/react-query";
import { ContextMenu } from "devextreme-react";
import { Item } from "devextreme/ui/context_menu";

type Props = {
  target: string;
  clientId: string | undefined;
  retirementAge: number;
  rowAge: number;
};

export default function SetRetirementCtxMenu({ target, clientId, retirementAge, rowAge }: Props) {
  const { mutateAsync } = useHouseholdDataUpdate(clientId!, HouseholdDataType.RetirementAge);
  const qc = useQueryClient();

  const isResetVisible = retirementAge === rowAge;

  const ctxItemsArr: Item[] = [
    { text: "Set retirement age", icon: "rename", visible: !isResetVisible },
    { text: "Reset", icon: "revert", visible: isResetVisible },
  ];

  return (
    <ContextMenu
      items={ctxItemsArr}
      width={200}
      target={target}
      onItemClick={(e) => {
        switch (e.itemData?.text?.toLowerCase()) {
          case "set retirement age":
            mutateAsync({
              data: rowAge,
            }).then(() => qc.invalidateQueries({ queryKey: ["householdData", clientId] }));
            break;
          case "reset":
            mutateAsync({
              data: undefined,
            }).then(() => qc.invalidateQueries({ queryKey: ["householdData", clientId] }));
            break;
        }
      }}
    />
  );
}
